
import React from 'react';
import { Link } from 'react-router-dom';
import FooterLinkGroup from './FooterLinkGroup';
import { FileText, Shield } from 'lucide-react';

export const LegalLinks: React.FC = () => {
  const links = [
    {
      to: "/terms#terms-top",
      label: "Terms of Use",
      icon: <FileText className="h-3.5 w-3.5" />
    },
    {
      to: "/privacy#privacy-top",
      label: "Privacy Policy",
      icon: <Shield className="h-3.5 w-3.5" />
    }
  ];

  return (
    <FooterLinkGroup title="Legal" links={links} />
  );
};
